// extracted by mini-css-extract-plugin
module.exports = {"card":"CautionCard_card__4KWTC","img":"CautionCard_img__2Z2kB","text":"CautionCard_text__1ww33"};